import { createSlice } from '@reduxjs/toolkit';
import {
  getSupplierCreditApplicationsReportExtraReducer,
  getSupplierCustomerArReportExtraReducer,
  getSupplierReportExtraReducer,
  getCustomerAnalyticsExtraReducer,
  getCreditManagerArPerformanceExtraReducer,
  getCreditReviewerPerformanceExtraReducer,
  getSupplierInvoiceCollectionNotesReportExtraReducer,
} from '../reducers/reportsReducers';
import {
  SupplierAnnualReport,
  SupplierCreditApplicationAnnualReport,
  CustomerAccountPreviewList,
  CustomerAnalyticsReport,
  CustomerAdoptionMetrics,
  CreditManagerArPerformanceReport,
  CreditManagerCreditPerformanceReport,
} from '@dill/dill-shared';
import { InvoiceCollectionNotesReportRow } from '../services/reportsService';

export interface ReportsInitialState {
  supplierAnnualReport?: SupplierAnnualReport | null;
  supplierCreditApplicationsAnnualReport?: SupplierCreditApplicationAnnualReport | null;
  customerAccountPreviewList?: CustomerAccountPreviewList | null;
  customerAnalyticsReport?: CustomerAnalyticsReport | null;
  customerAdoptionMetrics?: CustomerAdoptionMetrics | null;
  creditManagerArPerformanceReport?: CreditManagerArPerformanceReport | null;
  creditReviewerPerformanceReport?: CreditManagerCreditPerformanceReport | null;
  invoiceCollectionNotesReport?: InvoiceCollectionNotesReportRow[] | null;
  loadingList: string[];
}

const initialState: ReportsInitialState = {
  supplierAnnualReport: null,
  supplierCreditApplicationsAnnualReport: null,
  customerAccountPreviewList: null,
  customerAnalyticsReport: null,
  customerAdoptionMetrics: null,
  creditManagerArPerformanceReport: null,
  creditReviewerPerformanceReport: null,
  invoiceCollectionNotesReport: null,
  loadingList: [],
};

export const reportsSlice = createSlice({
  name: 'reports',
  initialState,
  reducers: {
    resetP21RootState: () => initialState,
  },
  extraReducers(builder) {
    getSupplierReportExtraReducer(builder);
    getSupplierCustomerArReportExtraReducer(builder);
    getSupplierCreditApplicationsReportExtraReducer(builder);
    getCustomerAnalyticsExtraReducer(builder);
    getCreditManagerArPerformanceExtraReducer(builder);
    getCreditReviewerPerformanceExtraReducer(builder);
    getSupplierInvoiceCollectionNotesReportExtraReducer(builder);
  },
});

export const { resetP21RootState } = reportsSlice.actions;
